import { Grid, Tooltip, tooltipClasses } from '@mui/material';
import PropTypes from 'prop-types';
import { styled } from '@mui/material/styles';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import { navigateToWorkspaceUrl } from '../../utils/navigator';
import { PROJECTS } from '../../constants/routes';
import { AvatarImage } from '../../components/Avatar';
import Button from '../../components/atoms/button';

const WorkspaceItem = ({ workspace, isLastItem }) => {
  const handleOpenWorkspace = () => {
    navigateToWorkspaceUrl(workspace.handle, `/${PROJECTS}`);
  };

  const LightTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} />
  ))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: theme.palette.common.white,
      color: 'rgba(0, 0, 0, 0.87)',
      boxShadow: theme.shadows[1],
      fontSize: 14,
      padding: '0.9rem',
      border: '1px solid #dadde9',
    },
  }));
  return (
    <div className={`workspace-item-grid ${workspace.isDisabled ? 'disabled' : ''}`}>
      <Grid container>
        <Grid item xs={1} sx={{ display: 'flex', alignItems: 'center' }}>
          <AvatarImage alt="Workspace Logo" src={workspace.logo} borderGray whiteAvatar initials={1} fontWeight={600} fontSize={22} height={50} width={50} name={workspace.name} />
        </Grid>
        <Grid item xs={11} container paddingTop={1.5} paddingBottom={1.5} sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', borderBottom: isLastItem ? '' : '1px solid #EAECF0' }}>
          <Grid direction="column" item container>
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
              <div className="item-workspace">
                <p className="item-workspace-name">{workspace.name}</p>
                <p className="item-workspace-description">{workspace.userCount} {workspace.userCount > 1 ? 'members' : 'member'}</p>
              </div>
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <LightTooltip
                  title="Your account is no longer active in this workspace. Please contact the workspace owner."
                  disableFocusListener
                  placement="left"
                >
                  <div>
                    <ErrorOutlineIcon
                      fontSize="small"
                      style={{
                        color: '#1D2939',
                        display: workspace.isDisabled ? 'block' : 'none',
                        marginRight: '0.5rem',
                      }}
                    />
                  </div>
                </LightTooltip>
                <Button className="workspace-open-or-join-button" primary small outlined onClick={handleOpenWorkspace} disabled={workspace.isDisabled}>
                  {workspace.isDisabled ? 'Disabled' : 'Open'}
                </Button>
              </div>
            </div>
          </Grid>
        </Grid>
      </Grid>
    </div>
  );
};

WorkspaceItem.propTypes = {
  workspace: PropTypes.shape({
    name: PropTypes.string.isRequired,
    userCount: PropTypes.number.isRequired,
    workspaceLogo: PropTypes.string,
    handle: PropTypes.string.isRequired,
    logo: PropTypes.string,
    isDisabled: PropTypes.bool,
  }).isRequired,
  isLastItem: PropTypes.bool.isRequired,
};

export default WorkspaceItem;
